import {
  Box,
  Button,
  CheckIcon,
  Flex,
  Hide,
  JaneGoldIcon,
  TagFilledIcon,
  Typography,
} from '@iheartjane/reefer';

import styles from '../specialDetailStatus.module.css';

/** Props for the special detail footer displaying qualification status and checkout CTA */
export interface SpecialDetailStatusFooterProps {
  /** Secondary text displayed below the footer text */
  footerSubtext?: string;
  /** Primary footer message (e.g., "Your deal is ready!") */
  footerText: string;
  /** Whether this is a Jane Gold special */
  isGold?: boolean;
  /** Callback fired when the checkout button is clicked */
  onCheckoutClick: () => void;
  /** Current qualifying status — footer only renders for "qualified" or "applied" */
  qualifyingStatus: string;
}
export const SpecialDetailStatusFooter = ({
  footerSubtext,
  footerText,
  isGold,
  onCheckoutClick,
  qualifyingStatus,
}: SpecialDetailStatusFooterProps) => {
  const isQualified = qualifyingStatus === 'qualified';
  const isApplied = qualifyingStatus === 'applied';

  return (
    <>
      <Hide isHidden as="aside" aria-live="polite" aria-atomic="true">
        {footerText}
        {footerSubtext}
      </Hide>
      {(isQualified || isApplied) && (
        <Box
          p={24}
          className={styles['footer__border']}
          border="transparent-black-ten"
          data-testid="special-detail-footer"
        >
          <Flex alignItems="center" pb={isApplied ? 16 : 0}>
            <Box background={isGold ? 'gold' : 'info'} borderRadius="xs" p={12}>
              {isGold && <JaneGoldIcon />}
              {!isGold && <TagFilledIcon color="grays-white" />}
            </Box>
            <Box mx={16}>
              <Typography variant="body-bold">{footerText}</Typography>

              {footerSubtext && (
                <Typography variant="mini" color="grays-mid">
                  {footerSubtext}
                </Typography>
              )}
            </Box>
            <CheckIcon ml="auto" />
          </Flex>
          {isApplied && (
            <Button
              full
              label="Checkout now"
              onClick={onCheckoutClick}
              className={styles['border__radius__lg']}
            />
          )}
        </Box>
      )}
    </>
  );
};
